
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useSubscriptionItemTranslate } from '@/modules/subscription/item/model/translate';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';

export default defineComponent({
    name: ROUTE_NAME_SUBSCRIPTION.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useSubscriptionItemTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
